import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIRecommendationChoiceWrapper } from './components/AIRecommendationChoiceWrapper';

async function loadAIRecommendationChoiceStep(): Promise<typeof AIRecommendationChoiceWrapper> {
	return (
		await import(
			/* webpackChunkName: "pages/start-a-petition-steps-ai-recommendation-choice" */ './components/AIRecommendationChoiceWrapper'
		)
	).AIRecommendationChoiceWrapper;
}

export const AIRecommendationChoiceLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadAIRecommendationChoiceStep}
			fallback={
				<Box margin="auto">
					<Spinner />
				</Box>
			}
		/>
	);
};

export const preloadAIRecommendationChoiceStep = loadAIRecommendationChoiceStep;
